import { render, staticRenderFns } from "./OverSpeedReport.vue?vue&type=template&id=72da4396&"
import script from "./OverSpeedReport.vue?vue&type=script&lang=js&"
export * from "./OverSpeedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports